module.exports = __webpack_public_path__ + "static/media/greatswords.b7c25642.png";